{
  "Clear search": "Απαλοιφή αναζήτησης"
}
